import React from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { BankInformationIcon } from 'components/common/icons';
import { Col, EditableInfoComponent, Row, Typography } from 'components';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { useBankInformation } from './useBankInformation';
import { BankInformationEditeModal } from './edit';

const { Text } = Typography;
export const SupplierBankInformation = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const { modalState, onModalStateChange, bank } = useBankInformation();
  return (
    <>
      <EditableInfoComponent
        title={'Bank Information'}
        editable={hasAccess(PERMISSIONS.suppliers.bank_information.write)}
        icon={<BankInformationIcon />}
        onEdite={onModalStateChange}
      />
      <Row gutter={[0, 4]}>
        <Col span={24}>
          <Row justify={'space-between'}>
            <Col>
              <Text type={'secondary'}>Bank Name</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>{bank?.name || 'Not Set'}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'}>
            <Col>
              <Text type={'secondary'}>Account Name</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>{bank?.accountName || 'Not Set'}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'}>
            <Col>
              <Text type={'secondary'}>Account Number</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>{bank?.accountNumber || 'Not Set'}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'}>
            <Col>
              <Text type={'secondary'}>SWIFT Number</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>{bank?.swift || 'Not Set'}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'}>
            <Col>
              <Text type={'secondary'}>IBAN</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>{bank?.iban || 'Not Set'}</Text>
            </Col>
          </Row>
        </Col>
      </Row>
      <BankInformationEditeModal modalState={modalState} onModalStateChange={onModalStateChange} dataToEdit={bank} />
    </>
  );
});
